<template>
  <p class="timer">{{ $t("resend_text") }} {{ currentTime }}</p>
</template>

<script>
import passwordRecoveryConfig from "@/config/passwordRecovery";

export default {
  props: {
    initialTime: {
      type: Number,
      default: passwordRecoveryConfig.recoveryCodeSendingDelay
    },
    interval: {
      type: Number,
      // Интервал по умолчанию - 1 секунда
      default: 1000
    }
  },
  data() {
    return {
      currentTime: this.initialTime,
      timer: null
    };
  },
  watch: {
    currentTime() {
      // Если счетчик дошел до конца, останавливаем таймер
      if (this.currentTime <= 0) {
        this.stopTimer();
        this.$emit("timerExpire");
      }
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => this.currentTime--, this.interval);
    },
    stopTimer() {
      clearInterval(this.timer);
    }
  },
  // При установке компонента создаем таймер
  mounted() {
    this.startTimer();
  },
  // Очищаем таймер, когда компонент удаляется со страницы
  destroyed() {
    this.stopTimer();
  }
};
</script>

<style scoped>
.timer {
  font-size: 16px;
  color: #ffffff;
}
</style>
